import React from "react"
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { Rating, RatingItem } from "@progress/kendo-react-inputs"
import { updateNode } from "../../Helpers/Nodes"
import InnerLoader from "../Loader/InnerLoader"
import { OverlayLoader } from "../Loader/OverlayLoader"

export const SavingChanges = () => {
    return (
        <div data-testid="savingChangesLoader" className="d-inline-block">
            <InnerLoader borderColor="green" />
            <span className="me-4 text-danger"></span>
            <OverlayLoader />
        </div>
    )
}

export const GetClassName = (props) => {
    let className = "btn btn-danger"
    if (props.selected) {
        className = "btn btn-primary"
    } else if (props.value > 8) {
        className = "btn btn-success"
    } else if (props.value > 6 && props.value < 9) {
        className = "btn btn-warning"
    }
    return className
}

export const CustomRatingComponent = (props) => {
    const className = GetClassName(props)
    return (
        <RatingItem {...props}>
            <div className={className}>
                {props.value}
            </div>
        </RatingItem>
    );
};

export const RatingComponent = ({ value, onUpdate, onDismiss, savingChanges }) => {
    return (
        <div className="text-center p-2">
            <p className="d-block">How is your experience using Codeless ONE?</p>
            <Rating
                value={value}
                onChange={onUpdate}
            />
            <div className="m-auto mt-3">
                <button
                    className="d-inline-block btn btn-secondary me-3"
                    onClick={() => onDismiss(true)}
                >
                    Remind me later
                </button>
                {savingChanges && <SavingChanges />}
            </div>
        </div>
    )
}

export const ImproveExperienceComponent = ({ value, onUpdate, onNext, onDismiss, savingChanges }) => {
    return (
        <div className="text-center px-4 py-2">
            <label htmlFor="improve-experience-text" className="d-block pb-3">How can we make CodelessONE a better experience for you? We're always open to new feature suggestion!</label>
            <textarea
                id="improve-experience-text"
                className="py-2 form-control d-inline-block"
                type={"text"}
                value={value}
                onChange={onUpdate}
            />
            <DialogActionsBar layout={'end'}>
                {savingChanges && <SavingChanges />}
                <button
                    className="btn btn-secondary"
                    onClick={() => onDismiss(true)}
                >
                    Remind me later
                </button>
                <button
                    className="btn btn-primary ms-2"
                    onClick={onNext}
                >
                    Continue
                </button>
            </DialogActionsBar >
        </div >
    )
}

export const RecommendedRatingComponent = ({ value, onUpdate, onDismiss, onSave, savingChanges }) => {

    return (
        <div className="text-center px-4 py-2">
            <p className="d-block pb-3">How likely are you to recommend CodelessONE to your friends and colleagues?</p>
            <Rating
                min={0}
                max={10}
                selection={"single"}
                value={value}
                onChange={onUpdate}
                item={CustomRatingComponent}
            />
            <div className="d-flex justify-content-between mx-3">
                <small>Not likely</small>
                <small>Extremely likely</small>
            </div>
            <DialogActionsBar layout={'end'}>
                {savingChanges && <SavingChanges />}
                <button
                    className="btn btn-secondary"
                    onClick={() => onDismiss(true)}
                >
                    Remind me later
                </button>
                <button
                    disabled={!value}
                    className="btn btn-primary ms-2"
                    onClick={() => onSave(false)}
                >
                    Submit
                </button>
            </DialogActionsBar >
        </div >
    )
}

export const RatingDialog = (props) => {
    const { user, onClose } = props

    const [savingChanges, setSavingChanges] = React.useState(false)
    const [rating, setRating] = React.useState(user.rating ? parseInt(user.rating) : 0)
    const [recommendRating, setRecommendRating] = React.useState(user.recommendRating ? parseInt(user.recommendRating) : 0)
    const [showRecommendedRating, setShowRecommendedRating] = React.useState(false)
    const [showImproveExperienceBy, setShowImproveExperienceBy] = React.useState(true)
    const [improveExperienceBy, setImproveExperienceBy] = React.useState(user.improveExperienceBy || "")

    const handleRatingChange = (event) => {
        setRating(event.value)
    }

    const handleImproveExperienceByChange = (event) => {
        setImproveExperienceBy(event.target.value)
    }

    const handleRecommendedRatingChange = (event) => {
        setRecommendRating(event.value)
    }

    const handleContinue = () => {
        setShowRecommendedRating(true)
        setShowImproveExperienceBy(false)
    }

    const saveUserFeedback = (remindMelaterForRating) => {
        setSavingChanges(true)
        const properties = {
            rating: rating,
            improveExperienceBy: improveExperienceBy,
            remindMelaterForRating: remindMelaterForRating,
            recommendRating: recommendRating
        }
        updateNode("User", user.id, properties)
        setSavingChanges(false)
        onClose()
    }

    return (
        <Dialog>
            {rating === 0 &&
                <RatingComponent
                    value={rating}
                    savingChanges={savingChanges}
                    onUpdate={handleRatingChange}
                    onDismiss={saveUserFeedback}
                />
            }
            {(rating > 0 && showImproveExperienceBy) &&
                <ImproveExperienceComponent
                    value={improveExperienceBy}
                    savingChanges={savingChanges}
                    onUpdate={handleImproveExperienceByChange}
                    onNext={handleContinue}
                    onDismiss={saveUserFeedback}
                />
            }
            {showRecommendedRating &&
                <RecommendedRatingComponent
                    value={recommendRating}
                    onUpdate={handleRecommendedRatingChange}
                    savingChanges={savingChanges}
                    onSave={saveUserFeedback}
                    onDismiss={saveUserFeedback}
                />
            }
        </Dialog>
    )
}